// @owners { team: patients }
import { createSelector } from 'reselect';
import { getCurrentUserLabels } from './getCurrentUserLabels';

// Matches the label from Scriptdash User#labels_for_api
const PROGYNY_SHOW_IU_LIMITATION_BULLET_LABEL = 'progyny_show_iu_limitation_bullet';

export const getShowProgynyIuLimitationBullet = createSelector([getCurrentUserLabels], (labels) => {
  return labels.includes(PROGYNY_SHOW_IU_LIMITATION_BULLET_LABEL);
});
